<div class="cmn-treenode-item" [ngStyle]="searchParams.cssStyle">
    <div class="caremoni-input-search" *ngIf="searchParams.type === 1"
        [ngClass]="{'no-border': comboInputFocus, 'required': _required}">
        <input class="caremoni-input" type="text" 
            placeholder="{{searchParams.placeholder}}" 
            id={{inputSearchId}}
            [disabled]="_disable" readonly 
            [ngModel]="searchValue" 
            (click)="onClickDropdown($event)" 
            [maxlength]="searchParams.maxLength || null"
            (focus)="handleComboInputFocus($event)" 
            (focusout)="handleComboInputFocusOut($event)"
            [ngClass]="{'border-red-err': notValidIds.includes(searchParams.objectData.selectedNode.id)}"
             />
        <div class="caremoni-icon dropdown-icon" [ngClass]="dspSearchPanel? 'icon-rotate': ''" (click)="onClickDropdown($event)"></div>
    </div>
    <div class="treenode-titles">
        <caremoni-treenode-titles 
            [_displayFilter]="_displayFilter" 
            (_onHide)="onHidePanelSearch()" 
            [_tempDataFilters]="searchParams.dataSource" 
            [isFilter]="isFilter"
            [defaultValue]="searchValue" 
            [displayText]="listFilterDspText" 
            [cssStyle]="popupStyle"
            [_selectedData]="selectedData"
            [placeHolderFilter]="placeHolderFilter" 
            [objectData]="searchParams.objectData" 
            (leafNodeClick)="onClickLeafNode($event)"
            >
        </caremoni-treenode-titles>
    </div>
</div>